import { render } from "./termAndConditions.vue?vue&type=template&id=3c6c87b6"
import script from "./termAndConditions.vue?vue&type=script&lang=js"
export * from "./termAndConditions.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__